import React from 'react';
import { Locked32 } from '@carbon/icons-react';
import { Flex, Box, Text, Tooltip } from '@chakra-ui/react';

const DataPointsLogoText: React.FC<{
  canUseElevatedPermissions: boolean;
  useElevatedPermissions: boolean;
}> = ({ canUseElevatedPermissions, useElevatedPermissions }) => (
  <Flex
    flexGrow={1}
    justifyContent="space-between"
    alignItems="center"
    mx={{ base: 2, lg: 0 }}
  >
    <Text
      color={useElevatedPermissions ? 'white' : 'gray.900'}
      fontSize="2xl"
      fontFamily="'Baskerville', serif"
    >
      Data
      <Text
        as="span"
        color="yellow.400"
        display="inline"
        fontSize="2xl"
        fontFamily="'Baskerville', serif"
        fontWeight="bold"
      >
        Points
      </Text>
    </Text>
    {canUseElevatedPermissions && useElevatedPermissions && (
      <Box color="white">
        <Tooltip label="You are using elevated permissions and will see data that a user without elevated permissions might not see">
          <Locked32 data-testid="locked-icon" />
        </Tooltip>
      </Box>
    )}
  </Flex>
);

export default DataPointsLogoText;
